import { Environment } from "@abacus/common";

export interface ApiResponse<T> {
  data: T;
  headers?: Record<string, string>;
  status: number;
}

export const baseUrls: Partial<Record<Environment, string>> = {
  [Environment.Prod]: "https://prod-ows-abacus-event.theorchard.io",
  [Environment.QA]: "https://qa-ows-abacus-event.theorchard.io",
  [Environment.UAT]: "https://uat-ows-abacus-event.theorchard.io",
};
